import React from 'react';
import { Timer } from '../../../atoms';
import { useTranslation } from '../../../../i18n/hooks/useTranslation';

interface TimerSelectionModalProps {
  isOpen: boolean;
  availableTimers: Array<{ name: string; duration: number }>;
  onSelectTimer: (timer: { name: string; duration: number }) => void;
  onClose: () => void;
}

export function TimerSelectionModal({
  isOpen,
  availableTimers,
  onSelectTimer,
  onClose
}: TimerSelectionModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 max-w-sm mx-4">
        <h3 className="text-lg font-semibold mb-4">{t('components.timer.availableTimers')}</h3>
        <div className="space-y-2 mb-4">
          {availableTimers.map((timer, index) => (
            <button
              key={index}
              onClick={() => onSelectTimer(timer)}
              className="w-full text-left p-2 hover:bg-gray-100"
            >
              {timer.name}
            </button>
          ))}
        </div>
        <button
          onClick={onClose}
          className="w-full bg-gray-500 text-white py-2"
        >
          {t('components.timer.close')}
        </button>
      </div>
    </div>
  );
}

interface ActiveTimerModalProps {
  isOpen: boolean;
  title: string;
  duration: number;
  onClose: () => void;
  onFifteenSeconds?: () => void;
  onTime?: () => void;
  onPause?: () => void;
  onResume?: () => void;
}

export function ActiveTimerModal({
  isOpen,
  title,
  duration,
  onClose,
  onFifteenSeconds,
  onTime,
  onPause,
  onResume
}: ActiveTimerModalProps) {
  if (!isOpen) return null;

  return (
    <Timer
      isOpen={true}
      title={title}
      duration={duration}
      onClose={onClose}
      onFifteenSeconds={onFifteenSeconds}
      onTime={onTime}
      onPause={onPause}
      onResume={onResume}
    />
  );
}